var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon',{class:{clickable:!_vm.readonly},attrs:{"icon":_vm.v ? 'check-circle-fill':'circle',"variant":_vm.readonly ? 'secondary' : 'primary'},on:{"click":_vm.toggle}})}
var staticRenderFns = []

export { render, staticRenderFns }